import React, { useState } from "react";
import store from '../../../store';
import { connect } from "react-redux";
import Button from "../common/input/Button";
import moment from "moment";
import { apiUrl } from "./constants";
import AccountLoader from "../../manageAccount/accountLoader";
import { GetRequest } from "./helper";
import { updatePnrEnqiryTripData } from "../../../actions/search-actions";
import TripDetails from "../trip/tripDetails";
import ViewBooking from "../../manageAccount/ViewBooking";
const Card = ({ val, setTripDetails, }) => {
    const [refreshStatus, setRefreshStatus] = useState(false);
    const [cancelRefund, setCancelRefund] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [ticket, showTicket] = useState(false);
    const [loader, setLoader] = useState(false);
    const propdata = store.getState();
    const tripData = propdata.search.pnrEnquiryTripData;
    const style = {
        position: 'absolute',
        top: '50%',
        left: '83%',
        transform: 'translate(-50%, -50%)',
        width: 328,
        height: 480,
        bgcolor: 'background.paper',
        border: '2px solid #fff',
        boxShadow: 24,
        p: 2,
        background: "#fff",
        border: "none"
    };

    const styleSecond = {
        position: 'absolute',
        top: '50%',
        left: '83%',
        transform: 'translate(-50%, -50%)',
        width: 328,
        height: 360,
        bgcolor: 'background.paper',
        border: '2px solid #fff',
        boxShadow: 24,
        p: 2,
        background: "#fff",
    };

    const showStatus = (el) => {
        let status = '';
        if (el.BookingStatus === 'B' || el.BookingStatus === "Booked" || el.BookingStatus === "Booking") {
            status = 'BOOKED';
        } else if (el.BookingStatus === 'C' || el.BookingStatus === 'Cancelled' || el.BookingStatus === 'Cancel') {
            status = 'CANCELLED';
        } else if (el.BookingStatus === 'Partial Cancel') {
            status = 'PART. CANCELLED';
        } else if ((el.TransactionStatus === 'success' || el.TransactionStatus === 'pass') && (el.pnrNo === '' || el.pnrNo === null)) {
            status = 'REFUND INITIATED';
        } else if (el.TransactionStatus === 'fail' && (el.pnrNo === '' || el.pnrNo === null)) {
            status = 'PAYMENT FAILED';
        } else if (el.TransactionStatus === 'pending') {
            status = 'PAYMENT PENDING';
        } else if (el.BookingStatus === 'PDBF') {
            status = 'REFUND INITIATED';
        } else {
            status = '';
        }
        return status;
    }

    const gotoTripDetails = (val) => {
        let pnr = val.NewPNR ? val.NewPNR : val.pnrNo;
        setLoader(true);
        const url = `${apiUrl.tripStatusDetails}?PNR=${pnr}&TripCode=${val.TripCode}&date=null`;
        GetRequest(url).then(result => {
            setLoader(false);
            if (result.IsSuccess) {
                // let res = JSON.parse(result.Data);
                let res = result.Data;
                let details = {}
                if ((res && res.length > 0)) {
                    details['topDtls'] = res;
                    details['pickdropDtls'] = res[0].PickupDetails;
                    // setData({ ...details });
                    store.dispatch(updatePnrEnqiryTripData(details));
                }
                else {
                    store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                }

            } else {
                store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
            }
        })
    }

    return (
        <>
            {loader && <AccountLoader />}
            {Object.keys(tripData.topDtls).length === 0 && Object.keys(tripData.pickdropDtls).length === 0 ?
                <div className="cards" style={{ border: 'none' }}>
                    <div className="card-header" style={{ backgroundColor: `#004F9E`, height: "44px" }}>
                        <div className="orderId" style={{ color: "#FFF" }}>
                            OB Ref. No: <span style={{ color: '#fff' }}>{val.OrderID && val.OrderID.split('_')[1]} ON {moment(val.BookingTime).format('HH:mm, DD MMM')}</span>
                        </div>
                        <div className="card-vl"></div>
                        <div className="pnrTicket">
                            <span style={{ color: "#FFF" }}>{val.BookingStatus === 'PDBF' ? 'PAYMENT SUCCESS & BOOK FAILED' : `PNR-Ticket: ${(val.pnrNo ? val.pnrNo : 'Not Booked')}`}</span>
                        </div>
                        <div className={(val.BookingStatus === 'Partial Cancel' ? 'partial-cancel' : (val.BookingStatus === 'PDBF' ? 'pdbf' : showStatus(val) && showStatus(val).toLowerCase())) + ' card-button button headingButton'} style={{ width: '150px' }}>{showStatus(val)}</div>
                    </div>
                    <div style={{ border: '1px solid rgba(0, 0, 0, 0.15)', borderTop: "none", borderBottomRightRadius: "10px", borderBottomLeftRadius: "10px" }}>
                        <div className="card-content">
                            <div className="trip-code">
                                <span>{val.BusDetails[0].FromCity}</span>
                                <span>{moment(val.BusDetails[0].PickupTime).format('HH:mm')}, {moment(val.BusDetails[0].PickupTime).format('DD MMM YY')}</span>
                                <span>Trip Code: <b> {val.TripCode}</b></span>
                            </div>
                            <div className="distance">
                                <span>
                                    <div className="circle"></div>
                                    <div className="hr"></div>
                                    <div className="square"></div>
                                </span>
                                <span>
                                    <div className="icon">
                                        {/* <img src="/Images/Truck.png" alt="Swift" /> */}
                                        <svg width="14" height="17" viewBox="0 0 14 17" fill="none">
                                            <path d="M2.18815 16.5013C2.0076 16.5013 1.84787 16.4492 1.70898 16.3451C1.5701 16.2409 1.50065 16.1055 1.50065 15.9388V14.1888C1.09787 13.9666 0.802734 13.6471 0.615234 13.2305C0.427734 12.8138 0.333984 12.3694 0.333984 11.8971V3.6263C0.333984 2.60322 0.865234 1.85439 1.92773 1.37982C2.99023 0.905254 4.68815 0.667969 7.02148 0.667969C9.32704 0.667969 11.0111 0.90408 12.0736 1.3763C13.1361 1.84852 13.6673 2.59852 13.6673 3.6263V11.8971C13.6673 12.3694 13.5736 12.8138 13.3861 13.2305C13.1986 13.6471 12.9034 13.9666 12.5007 14.1888V15.9388C12.5007 16.1055 12.4312 16.2409 12.2923 16.3451C12.1534 16.4492 11.9937 16.5013 11.8132 16.5013H11.4173C11.2166 16.5013 11.0484 16.4492 10.9126 16.3451C10.7769 16.2409 10.709 16.1055 10.709 15.9388V14.793H3.29232V15.9388C3.29232 16.1055 3.22444 16.2409 3.08867 16.3451C2.95291 16.4492 2.78468 16.5013 2.58398 16.5013H2.18815ZM1.58398 7.9388H12.4173V4.33464H1.58398V7.9388ZM3.79355 12.5013C4.11217 12.5013 4.3826 12.3898 4.60482 12.1667C4.82704 11.9437 4.93815 11.6729 4.93815 11.3542C4.93815 11.0356 4.82663 10.7652 4.60359 10.543C4.38055 10.3207 4.10971 10.2096 3.79109 10.2096C3.47246 10.2096 3.20204 10.3212 2.97982 10.5442C2.7576 10.7672 2.64648 11.0381 2.64648 11.3567C2.64648 11.6753 2.758 11.9457 2.98105 12.168C3.20409 12.3902 3.47492 12.5013 3.79355 12.5013ZM10.2102 12.5013C10.5288 12.5013 10.7993 12.3898 11.0215 12.1667C11.2437 11.9437 11.3548 11.6729 11.3548 11.3542C11.3548 11.0356 11.2433 10.7652 11.0203 10.543C10.7972 10.3207 10.5264 10.2096 10.2078 10.2096C9.88913 10.2096 9.61871 10.3212 9.39648 10.5442C9.17426 10.7672 9.06315 11.0381 9.06315 11.3567C9.06315 11.6753 9.17467 11.9457 9.39771 12.168C9.62076 12.3902 9.89159 12.5013 10.2102 12.5013Z" fill="#444444" />
                                        </svg>
                                        {/* <FontAwesomeIcon icon={faTruckFront} color={"#444444"} /> */}
                                    </div>
                                    <div className="text" title="Swift Gajaraj Multi Axle Volvo A/C..">
                                        {val.BusDetails[0].BusType}
                                    </div>
                                </span>
                            </div>
                            <div className="date">
                                <span>{val.BusDetails[0].ToCity}</span>
                                <span>{moment(val.BusDetails[0].DropoffTime).format('HH:mm')}, {moment(val.BusDetails[0].DropoffTime).format('DD MMM YY')}</span>
                            </div>
                            <div className="buttons">
                                <div className="content-button">

                                    {val.BookingStatus === 'Partial Cancel' && <Button text={"REFUND INITIATED"} className={`button refund`} extraStyle={{ width: "150px", }} />}
                                    {
                                        val.pnrNo && (val.BookingStatus === 'B' || val.BookingStatus === 'Booked' || val.BookingStatus === 'Booking') && <Button text={ticket ? "CLOSE TICKET" : "VIEW TICKET"} className={`button active`} extraStyle={{ width: "150px", }} onClick={() => showTicket(!ticket)} />
                                    }
                                    {
                                        val.pnrNo && (val.BookingStatus === 'C' || val.BookingStatus === 'Cancelled' || val.BookingStatus === 'Cancel') && <Button text={"BOOK AGAIN"} className={`button modified`} extraStyle={{ width: "150px", }} onClick={() => window.location.href = `/`} />
                                    }
                                    {
                                        (val.TransactionStatus === 'fail' || val.TransactionStatus === 'success') && (val.pnrNo === '' || val.pnrNo === null) && <Button text={"RETRY BOOKING"} className={`button active`} extraStyle={{ width: "150px", }} onClick={() => window.location.href = `/`} />
                                    }

                                    {
                                        (val.BookingStatus === 'PDBF') && <Button text={"RETRY BOOKING"} className={`button active`} extraStyle={{ width: "150px", }} onClick={() => window.location.href = `/`} />
                                    }

                                </div>
                                <div className="content-button">
                                    {
                                        (val.TripStatus === 'Scheduled' && (val.BookingStatus !== 'C' && val.BookingStatus !== 'Cancelled' && val.BookingStatus !== 'Cancel' && val.BookingStatus !== 'PDBF')) && <Button text={"TRIP SCHEDULED"} className={`button modified`} extraStyle={{ width: "150px", paddingRight: "10px", }} onClick={() => gotoTripDetails(val)} />
                                    }
                                    {
                                        (val.TripStatus === 'Ended' && (val.BookingStatus !== 'C' && val.BookingStatus !== 'Cancelled' && val.BookingStatus !== 'Cancel' && val.BookingStatus !== 'PDBF')) && <Button text={"TRIP COMPLETED"} className={`button modified`} extraStyle={{ width: "150px", paddingRight: "10px", color: '' }} />
                                    }
                                    {
                                        (val.TripStatus === 'Cancelled' && val.BookingStatus !== 'PDBF') && <Button text={"TRIP CANCELLED"} className={`button modified`} extraStyle={{ width: "150px", paddingRight: "10px", color: '' }} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="left-side">
                                <span >Booking's Payment Gateway Transaction ID: <span > {val.TransactionID}</span></span>
                                {/* {val.PGName ? <span style={{ fontWeight: '600', color: '#444', textTransform: 'capitalize' }}>{` | ${val.PGName}`}</span> : ""} */}
                                {
                                    val.BookingStatus === 'Partial Cancel' ?
                                        <>
                                            <span className="card-vl"></span>
                                            <span>New PNR-Ticket: {val.NewPNR}-{val.pnrNo.split("-")[1]}</span>
                                        </> : ""
                                }
                            </div>
                            <div className="right-side">
                                <div className="content-button">
                                    {val.BookingStatus === 'Partial Cancel' && <Button text={"NEW PNR ISSUED"} className={`button active`} extraStyle={{ width: "150px", }} onClick={() => window.location.href = `/ticket/viewbookingStatus?pnrNo=${val.NewPNR}`} />}
                                    {(val.BookingStatus === 'B' || val.BookingStatus === 'Booking') && (val.TransactionStatus === 'pass' || val.TransactionStatus === 'success') && <Button text={"PAYMENT SUCCESS"} className={`button disable`} extraStyle={{ width: "150px", }} />}
                                    {(val.BookingStatus === 'C' || val.BookingStatus === 'Cancelled' || val.BookingStatus === 'Cancel') && <Button text={"REFUND INITIATED"} className={`button refund`} extraStyle={{ width: "150px", }} />}
                                    {(val.TransactionStatus === 'pending') && <Button text={"REFRESH STATUS"} className={`button active`} extraStyle={{ width: "150px", }} onClick={() => setRefreshStatus(true)} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className='booking-cards'>
                    <TripDetails topDtls={tripData.topDtls} pickdropDtls={tripData.pickdropDtls} />
                </div>
            }
            {
                ticket &&
                <div className="viewBooking-wrapper">
                    <ViewBooking pnr={val.pnrNo} />
                </div>
            }
        </>
    );
};

const mapStateToProps = function (store) {
    return store;
};
export default connect(mapStateToProps)(Card);

